<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
          v-col(cols="12" sm="6" md="4")
            BasePasswordField(rules="required" v-model="form.password", :label="translations.label.password", :showProgress="true")
          v-col(cols="12" sm="6" md="4")
            BasePasswordField(rules="required" v-model="form.repeatpassword", :label="translations.label.repeatpassword", :confirm="form.password")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required|email" v-model="form.email", :label="translations.label.email")
          v-col(cols="12" sm="6" md="4")
            BasePhoneField(rules="required" v-model="form.phone", :label="translations.label.phone")
          v-col(cols="12" sm="6" md="4")
            ValidationProvider(rules="required" v-slot="{ errors }")
              v-select(:items="roles" v-model="form.rol", :error="errors.length > 0" @change="form.bookmaker = ''")
                template(v-slot:label)
                  v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                  | {{ translations.label.rol }}
              span.red--text.text--accent-2(v-if="errors.length > 0")
                v-icon(color="red accent-2") mdi-alert
                |  {{ errors[0] }}
          v-col(cols="12" sm="6" md="4")
            ValidationProvider(:rules="{'required': requiredBookmaker}" v-slot="{ errors }")
              v-select(:items="operatorsListAll" v-model="form.bookmaker", :error="errors.length > 0", :disabled="!requiredBookmaker")
                template(v-slot:label)
                  v-icon.pr-1(v-show="requiredBookmaker" color="red accent-2" size="12") mdi-asterisk
                  | {{ translations.label.bookmaker }}
              span.red--text.text--accent-2(v-if="errors.length > 0")
                v-icon(color="red accent-2") mdi-alert
                |  {{ errors[0] }}
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingEdit") {{ translations.buttons.edit }}
</template>

<script>

  import { roles } from '@/store/variablesGlobals.js';

  export default {
    name: "AdministratorEdit",
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      user: {
        type: Object,
        default: function(){
          return {}
        }
      },
      operatorsListAll: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      form: {
        name: '',
        password: '',
        repeatpassword: '',
        email: '',
        phone: '',
        rol: '',
        bookmaker: ''
      },
      roles: roles,
    }),
    computed: {
      loadingEdit(){
        return this.$store.state.statusCode.editUser.loading;
      },
      stateEdit(){
        return this.$store.state.statusCode.editUser.state;
      },
      requiredBookmaker(){
        if (this.form.rol == 'viewer' || this.form.rol == 'user'){
          return true;
        } else {
          return false;
        }
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.setFields();
          this.$refs.validator.reset();
        }
      },
      stateEdit: function(val){
        if (val == 200){
          this.$emit('successEdit');
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      submitDataForm(){
        let formSend = {
          _id: this.user._id,
          data: {
            name: this.form.name,
            password: this.form.password,
            email: this.form.email,
            phone: this.form.phone,
            rol: this.form.rol,
          }
        };
        if (this.form.bookmaker != ''){
          formSend.data.bookmaker = this.form.bookmaker;
        }
        this.$store.dispatch('editUser', formSend);
      },
      setFields(){
        this.form.name = this.user.name;
        this.form.password = '';
        this.form.repeatpassword = '';
        this.form.email = this.user.email;
        this.form.phone = this.user.phone;
        this.form.rol = this.user.rol;
        this.form.bookmaker = this.user.bookmaker.id;
      },
    }
  }
</script>

<style lang="sass">
</style>